import { useState, useEffect, useCallback, Component } from "react";

const API = "https://app.carthub.cloud/api";

/** Icone stroke monocolore — stesso linguaggio della dashboard (`shared.js` / agency). */
const Ic = {
  menu: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <line x1="4" y1="6" x2="20" y2="6" /><line x1="4" y1="12" x2="20" y2="12" /><line x1="4" y1="18" x2="20" y2="18" />
    </svg>
  ),
  overview: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
      <rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  ),
  merchants: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 0 1-8 0" />
    </svg>
  ),
  agencies: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" /><path d="M6 12h12" /><path d="M6 16h12" /><path d="M10 22v-4h4v4" />
    </svg>
  ),
  ai: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  deliverability: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  fallback: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  warmup: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  refresh: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  logout: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
  users: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  link: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  alertLg: (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  checkSm: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  xSm: (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  clock: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  plugin: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M12 22v-6" /><path d="M9 7V2" /><path d="M15 7V2" /><path d="M6 13a4 4 0 0 0-2 3v1h16v-1a4 4 0 0 0-2-3" /><path d="M9 13V9a3 3 0 0 1 6 0v4" />
    </svg>
  ),
  globalLearning: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" /><path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
    </svg>
  ),
};

function H2Icon({ icon, children }) {
  return (
    <h2 style={{ display: "flex", alignItems: "center", gap: 8, margin: "0 0 16px 0", fontSize: 15, fontWeight: 600, color: "#1a1a1a" }}>
      <span style={{ display: "flex", color: "var(--text2)" }}>{icon}</span>
      <span>{children}</span>
    </h2>
  );
}

// ─── Cache in memoria — TTL 60s per tab ───────────────────────────────────────
const cache = {};
function getCached(key) {
  const e = cache[key];
  if (!e) return null;
  if (Date.now() - e.ts > 60000) { delete cache[key]; return null; }
  return e.data;
}
function setCached(key, data) { cache[key] = { data, ts: Date.now() }; }

function useAdminData(endpoint, token) {
  const [data, setData]       = useState(() => getCached(endpoint));
  const [loading, setLoading] = useState(!getCached(endpoint));
  const [error, setError]     = useState(false);

  const load = useCallback((force = false) => {
    if (!force) {
      const cached = getCached(endpoint);
      if (cached) { setData(cached); setLoading(false); return; }
    }
    setLoading(true); setError(false);
    fetch(`${API}${endpoint}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { setCached(endpoint, d); setData(d); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, [endpoint, token]);

  useEffect(() => { load(); }, [load]);
  return { data, loading, error, reload: () => { delete cache[endpoint]; load(true); } };
}

const styles = `
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --font: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --text:          #1a1a1a;
  --text2:         #6b7280;
  --text3:         #9ca3af;
  --border:        rgba(26, 26, 26, 0.08);
  --border2:       rgba(26, 26, 26, 0.12);
  --canvas:        #FBFDF7;
  --surface-panel: #ffffff;
  --surface-bright:#ffffff;
  --bg:            var(--canvas);
  --surface:       var(--surface-bright);
  --radius-module: 18px;
  --gap-module:    8px;
  --shadow-module: 0 5px 10px rgba(26, 26, 26, 0.05);
  --shadow-drawer: 0 8px 28px rgba(0, 0, 0, 0.18);
  --accent:        #0A85CF;
  --accent-hover:  #0878b8;
  --link:          #0A85CF;
  --accent-bg:     #e8f4fc;
  --accent-border: #b8daf2;
  --accent-glow:   rgba(10,133,207,0.18);
  --green:         #2e7d32;
  --green-bg:      #f0faf0;
  --green-border:  #c8e6c9;
  --red:           #c62828;
  --red-bg:        #fff5f5;
  --red-border:    #ffcdd2;
  --yellow:        #e65100;
  --yellow-bg:     #fff8f0;
  --yellow-border: #ffe0b2;
  --sidebar-dark:  #1b1b1b;
  --sidebar-border: rgba(255,255,255,0.08);
}

html, body, #root {
  height: 100%;
  font-family: var(--font);
  font-size: 15px;
  color: var(--text);
  background: var(--canvas);
  -webkit-font-smoothing: antialiased;
}
::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--border); border-radius: 2px; }

.app-loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 16px;
  background: var(--canvas);
  color: var(--text2);
  font-size: 15px;
  font-weight: 500;
}
.app-loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(26, 26, 26, 0.08);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: ch-spin 0.8s linear infinite;
}
@keyframes ch-spin { to { transform: rotate(360deg); } }

.app { display: flex; height: 100vh; overflow: hidden; background: var(--canvas); box-sizing: border-box; }

.sidebar-backdrop {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(26, 26, 26, 0.28);
  z-index: 180;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}
.sidebar-backdrop.is-open {
  display: block;
  opacity: 1;
  pointer-events: auto;
}

.mobile-nav-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-right: 10px;
  margin-left: -4px;
  border: none;
  border-radius: 12px;
  background: var(--surface-bright);
  color: var(--text);
  cursor: pointer;
  box-shadow: var(--shadow-module);
  flex-shrink: 0;
  transition: color 0.15s, box-shadow 0.15s;
}
.mobile-nav-toggle:hover { color: var(--accent); }

.sidebar {
  width: 290px;
  margin: var(--gap-module);
  background: var(--sidebar-dark);
  border: none;
  border-radius: var(--radius-module);
  box-shadow: var(--shadow-module);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
.sidebar-head {
  padding: 18px 16px 14px;
  border-bottom: 1px solid var(--sidebar-border);
}
.sidebar-logo {
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #f9fafb;
}
.sidebar-logo span { color: var(--accent); }
.sidebar-sub { font-size: 13px; color: rgba(255,255,255,0.45); margin-top: 2px; }

.sidebar-nav { padding: 10px 8px; flex: 1; }
.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  color: rgba(255,255,255,0.62);
  font-size: 15px;
  font-weight: 500;
  transition: background .15s, color .15s, border-color .15s;
  margin-bottom: 2px;
  border: 1px solid transparent;
  user-select: none;
}
.nav-item:hover {
  background: rgba(255,255,255,0.06);
  color: #fff;
}
.nav-item.active {
  background: rgba(10, 133, 207, 0.16);
  color: #93c5fc;
  border-color: rgba(10, 133, 207, 0.38);
}
.nav-item svg { width: 15px; height: 15px; flex-shrink: 0; }
.nav-badge {
  margin-left: auto;
  background: var(--accent);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 20px;
  line-height: 18px;
}

.sidebar-foot { padding: 12px; border-top: 1px solid var(--sidebar-border); }
.admin-row { display: flex; align-items: center; gap: 10px; }
.admin-av {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(10, 133, 207, 0.2);
  border: 1px solid rgba(10, 133, 207, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #93c5fc;
  flex-shrink: 0;
}
.admin-email {
  font-size: 13px;
  color: rgba(255,255,255,0.45);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.logout-btn {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255,255,255,0.45);
  padding: 6px;
  border-radius: 8px;
  transition: color .15s, background .15s;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logout-btn:hover { color: #fca5a5; background: rgba(248,113,113,0.12); }

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--canvas);
  min-width: 0;
}
.topbar {
  min-height: 56px;
  margin: var(--gap-module);
  background: var(--surface-panel);
  border: none;
  border-radius: var(--radius-module);
  box-shadow: var(--shadow-module);
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 10px;
  flex-shrink: 0;
  flex-wrap: wrap;
}
.topbar-title { font-size: 15px; font-weight: 600; flex: 1; min-width: 0; }

.content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: var(--gap-module);
  padding-top: 0;
  min-width: 0;
}

.ch-card { background: var(--surface-panel); border: 1px solid var(--border); border-radius: 12px; padding: 24px; margin-bottom: 20px; box-shadow: var(--shadow-module); }
.ch-card h2 { font-size: 15px; font-weight: 600; color: #1a1a1a; margin: 0 0 16px 0; }
.ch-btn { display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; font-size: 15px; font-weight: 500; border-radius: 10px; border: 1px solid var(--border); background: var(--surface-bright); color: #1a1a1a; cursor: pointer; transition: all .15s; font-family: var(--font); white-space: nowrap; }
.ch-btn:hover { background: #f9fafb; border-color: var(--border2); }
.ch-btn:disabled { opacity: .5; cursor: not-allowed; }
.ch-btn.danger  { color: var(--red);   border-color: var(--red-border);   } .ch-btn.danger:hover  { background: var(--red-bg);   }
.ch-btn.success { color: var(--green); border-color: var(--green-border); } .ch-btn.success:hover { background: var(--green-bg); }
.ch-btn.blue    { color: #1e40af;      border-color: #bfdbfe;             } .ch-btn.blue:hover    { background: #dbeafe;        }
.ch-search { padding: 9px 12px; font-size: 15px; font-family: var(--font); border: 1px solid var(--border); border-radius: 12px; outline: none; color: #1a1a1a; transition: border-color .15s, box-shadow .15s; background: var(--surface-bright); width: 100%; margin-bottom: 16px; }
.ch-search:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-glow); }
.ch-info    { background: var(--accent-bg); border: 1px solid var(--accent-border); border-radius: 10px; padding: 12px 16px; font-size: 14px; color: var(--text2); margin-bottom: 16px; }
.ch-success { background: var(--green-bg); border: 1px solid var(--green-border); border-radius: 6px; padding: 12px 16px; font-size: 14px; color: var(--green); margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between; }
.ch-status { font-size: 13px; font-weight: 500; padding: 3px 10px; border-radius: 20px; display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }
.ch-status.success { color: #2e7d32; background: #f0faf0; border: 1px solid #c8e6c9; }
.ch-status.error   { color: #c62828; background: #fff5f5; border: 1px solid #ffcdd2; }
.ch-status.warning { color: #e65100; background: #fff8f0; border: 1px solid #ffe0b2; }
.ch-status.neutral { color: #6b7280; background: #f5f5f5; border: 1px solid #e5e5e5; }
.ch-status.info    { color: var(--accent); background: var(--accent-bg); border: 1px solid var(--accent-border); }
.ch-status.blue    { color: #1e40af; background: #dbeafe; border: 1px solid #bfdbfe; }
.status-dot { width: 5px; height: 5px; border-radius: 50%; background: currentColor; }
.table-wrap { overflow-x: auto; }
table { width: 100%; border-collapse: collapse; font-size: 15px; }
thead th { padding: 8px 14px; text-align: left; font-size: 13px; font-weight: 600; color: #9ca3af; text-transform: uppercase; letter-spacing: .05em; border-bottom: 1px solid #e5e5e5; background: #f9fafb; white-space: nowrap; }
tbody tr { border-bottom: 1px solid #f5f5f5; transition: background .1s; }
tbody tr:last-child { border-bottom: none; }
tbody tr:hover { background: #fafafa; }
tbody td { padding: 12px 14px; vertical-align: middle; color: #1a1a1a; }
.td-muted { color: #6b7280; }
.td-sm { font-size: 13px; color: #9ca3af; margin-top: 2px; }
.stats-grid   { display: grid; grid-template-columns: repeat(4,1fr); gap: 16px; margin-bottom: 20px; }
.stats-grid-3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; margin-bottom: 20px; }
.stat-card { background: var(--surface-panel); border: 1px solid var(--border); border-radius: 12px; padding: 20px; box-shadow: var(--shadow-module); }
.stat-label { font-size: 13px; font-weight: 500; color: #6b7280; margin-bottom: 8px; }
.stat-val { font-size: 26px; font-weight: 600; color: #1a1a1a; line-height: 1; margin-bottom: 6px; }
.stat-val.accent { color: var(--accent); }
.stat-val.green  { color: #2e7d32; }
.stat-val.red    { color: #c62828; }
.stat-sub { font-size: 13px; color: #9ca3af; }
.grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
.empty { text-align: center; padding: 48px 20px; color: #9ca3af; font-size: 15px; }
.empty-icon { font-size: 28px; opacity: .5; margin-bottom: 8px; }
.empty-spinner { width: 32px; height: 32px; margin: 0 auto 12px; border-width: 2px; }
.empty-svg { display: flex; justify-content: center; margin-bottom: 10px; opacity: 0.88; }
.pill { font-size: 13px; color: #6b7280; background: #f5f5f5; border: 1px solid #e5e5e5; border-radius: 20px; padding: 3px 10px; }
.pill.green { color: #2e7d32; background: #f0faf0; border-color: #c8e6c9; }
.copy-value { background: #f5f5f5; border: 1px solid #e5e5e5; border-radius: 6px; padding: 4px 8px; font-size: 12px; color: #6b7280; font-family: monospace; word-break: break-all; }
.section-title { font-size: 18px; font-weight: 600; margin-bottom: 4px; }
.section-sub   { font-size: 13px; color: var(--text3); margin-bottom: 20px; }

.trend-chart { display: flex; align-items: flex-end; gap: 5px; height: 90px; padding-bottom: 20px; }
.trend-bar-wrap { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 2px; height: 100%; justify-content: flex-end; }
.trend-bar { width: 100%; background: var(--accent); border-radius: 3px 3px 0 0; opacity: 0.85; }
.trend-bar.empty { background: var(--accent-border); opacity: 0.55; height: 3px !important; }
.trend-label { font-size: 9px; color: #9ca3af; transform: rotate(-35deg); white-space: nowrap; margin-top: 4px; }
.trend-val { font-size: 9px; color: #9ca3af; }

.login-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background-color: #1b1b1b;
  background-image: url('https://carthub.cloud/wp-content/uploads/2026/03/svgviewer-output-dark.svg');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.login-card {
  width: 100%;
  max-width: 400px;
  background: #111111;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: var(--radius-module);
  padding: 40px 36px;
  box-shadow: var(--shadow-drawer);
}
.login-head { text-align: center; margin-bottom: 28px; }
.login-logo {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.03em;
  margin-bottom: 6px;
  color: #fff;
  line-height: 1.15;
}
.login-logo span { color: var(--accent); }
.login-sub { font-size: 15px; color: #fff; margin-top: 4px; }
.login-label { display: block; font-size: 14px; font-weight: 500; color: #fff; margin-bottom: 6px; }
.login-field { margin-bottom: 16px; }
.login-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 15px;
  font-family: var(--font);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  color: #fff;
  background: #1a1a1a;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.login-input::placeholder { color: rgba(255,255,255,0.38); }
.login-input:focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-glow); }
.login-btn {
  width: 100%;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 11px;
  font-family: var(--font);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s;
  margin-top: 8px;
}
.login-btn:hover { background: var(--accent-hover); }
.login-btn:disabled { opacity: .5; cursor: not-allowed; }
.login-err {
  background: rgba(127, 29, 29, 0.35);
  border: 1px solid rgba(248, 113, 113, 0.35);
  border-radius: 8px;
  color: #fecaca;
  font-size: 13px;
  padding: 10px 12px;
  margin-top: 14px;
  line-height: 1.4;
}

@media (max-width: 1100px) {
  .stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .stats-grid-3 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 900px) {
  .mobile-nav-toggle { display: inline-flex; }
  .sidebar {
    position: fixed;
    left: var(--gap-module);
    top: var(--gap-module);
    bottom: var(--gap-module);
    z-index: 200;
    width: min(290px, calc(100vw - 16px));
    margin: 0;
    transform: translateX(calc(-100% - var(--gap-module)));
    transition: transform 0.22s ease;
  }
  .sidebar.is-open {
    transform: translateX(0);
    box-shadow: var(--shadow-drawer);
  }
  .topbar { padding-left: 12px; padding-right: 12px; }
  .topbar-title { flex: 1 1 auto; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}
@media (max-width: 600px) {
  .stats-grid, .stats-grid-3 { grid-template-columns: 1fr !important; }
  .grid-2 { grid-template-columns: 1fr; }
}
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
`;

const fmtNum      = v  => new Intl.NumberFormat("it-IT").format(parseInt(v || 0));
const fmtDate     = ts => !ts ? "—" : new Date(ts).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
const fmtDateTime = ts => !ts ? "—" : new Date(ts).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
const fmtUSD      = v  => `$${parseFloat(v || 0).toFixed(4)}`;

function Badge({ status, text }) {
  const map = { ok:"success", warning:"warning", throttled:"error", suspended:"error", pro_active:"blue", pro_pending:"warning", quick_start:"neutral", active:"success", inactive:"neutral" };
  return <span className={`ch-status ${map[status] || "neutral"}`}><span className="status-dot" />{text || status}</span>;
}

function Loader() {
  return (
    <div className="empty">
      <div className="app-loading-spinner empty-spinner" aria-hidden />
      Caricamento…
    </div>
  );
}
function ErrMsg() {
  return (
    <div className="empty">
      <div className="empty-svg" style={{ color: "var(--yellow)" }}>{Ic.alertLg}</div>
      Errore nel caricamento dati
    </div>
  );
}
function SectionHead({ title, sub, onReload }) {
  return (
    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 20, gap: 12, flexWrap: "wrap" }}>
      <div style={{ minWidth: 0 }}>
        <div className="section-title">{title}</div>
        {sub && <div className="section-sub">{sub}</div>}
      </div>
      {onReload && (
        <button type="button" className="ch-btn" onClick={onReload}>
          <span style={{ display: "flex", color: "var(--text2)" }}>{Ic.refresh}</span>
          Aggiorna
        </button>
      )}
    </div>
  );
}

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault(); setLoading(true); setError("");
    try {
      const res = await fetch(`${API}/admin/login`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ email, password }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Login fallito");
      localStorage.setItem("carthub_admin_token", data.token);
      localStorage.setItem("carthub_admin", JSON.stringify(data.admin));
      onLogin(data.token, data.admin);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-head">
          <div className="login-logo" aria-label="CartHub">
            Cart<span>Hub</span>
          </div>
          <div className="login-sub">Pannello Superadmin</div>
        </div>
        {error && <div className="login-err">{error}</div>}
        <form onSubmit={submit}>
          <div className="login-field"><label className="login-label">Email</label><input className="login-input" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="admin@carthub.cloud" required /></div>
          <div className="login-field"><label className="login-label">Password</label><input className="login-input" type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required /></div>
          <button className="login-btn" type="submit" disabled={loading}>{loading ? "Accesso..." : "Accedi →"}</button>
        </form>
      </div>
    </div>
  );
}

function Overview({ token }) {
  const { data, loading, error, reload } = useAdminData("/admin/overview", token);
  if (loading) return <Loader />;
  if (error || !data) return <ErrMsg />;
  const { merchants, emails, ai, carts, daily_trend } = data;
  const maxBar = Math.max(...(daily_trend||[]).map(d=>parseInt(d.emails_sent||0)), 1);

  return (
    <div>
      <SectionHead title="Overview Globale" sub="Ultimi 30 giorni · carrelli, email inviate, trend e AI = solo shop produzione (non shadow) e decisioni live" onReload={reload} />
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Merchant Totali</div><div className="stat-val">{fmtNum(merchants.total)}</div><div className="stat-sub">{merchants.active} attivi · {merchants.pro_tier} Pro Tier</div></div>
        <div className="stat-card"><div className="stat-label">Recovery Rate Globale</div><div className="stat-val accent">{carts.recovery_rate_global||0}%</div><div className="stat-sub">{fmtNum(carts.recovered_carts)} / {fmtNum(carts.total_carts)} carrelli</div></div>
        <div className="stat-card"><div className="stat-label">Revenue Recuperato</div><div className="stat-val green">€{parseFloat(carts.revenue_recovered||0).toLocaleString("it-IT",{minimumFractionDigits:2})}</div><div className="stat-sub">ultimi 30 giorni</div></div>
        <div className="stat-card"><div className="stat-label">Costo AI Totale</div><div className="stat-val">{fmtUSD(ai.total_cost_usd)}</div><div className="stat-sub">{fmtNum(ai.total_tokens)} token · {ai.fallback_rate||0}% fallback</div></div>
      </div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Email Inviate (30d)</div><div className="stat-val">{fmtNum(emails.emails_sent_30d)}</div><div className="stat-sub">{fmtNum(emails.bounces_30d)} bounce</div></div>
        <div className="stat-card"><div className="stat-label">Bounce Rate Globale</div><div className={`stat-val ${parseFloat(emails.bounce_rate_global)>5?"red":parseFloat(emails.bounce_rate_global)>3?"accent":"green"}`}>{emails.bounce_rate_global||0}%</div><div className="stat-sub">media globale</div></div>
        <div className="stat-card"><div className="stat-label">Sospesi / Throttled</div><div className={`stat-val ${parseInt(merchants.suspended)>0?"red":"green"}`}>{fmtNum(merchants.suspended)}</div><div className="stat-sub">{merchants.throttled} throttled · {merchants.warning} warning</div></div>
        <div className="stat-card"><div className="stat-label">Decisioni AI</div><div className="stat-val">{fmtNum(ai.total_decisions)}</div><div className="stat-sub">{fmtNum(ai.fallback_count)} fallback</div></div>
      </div>
      <div className="ch-card">
        <h2>Email inviate — ultimi 14 giorni</h2>
        <div className="trend-chart">
          {(daily_trend||[]).map((d,i)=>{
            const count = parseInt(d.emails_sent||0);
            const h = count===0 ? 0 : Math.max((count/maxBar)*68, 4);
            return (
              <div key={i} className="trend-bar-wrap">
                <span className="trend-val">{count>0?count:""}</span>
                <div className={`trend-bar${count===0?" empty":""}`} style={count>0?{height:h}:{}} title={`${d.day}: ${count} email`} />
                <span className="trend-label">{new Date(d.day).toLocaleDateString("it-IT",{day:"2-digit",month:"2-digit"})}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function Merchants({ token }) {
  const { data, loading, error, reload } = useAdminData("/admin/merchants", token);
  const [actionLoading, setActionLoading] = useState(null);
  const [newKey, setNewKey] = useState(null);
  const [search, setSearch] = useState("");
  const [purgeModal, setPurgeModal] = useState(null);
  const [purgeInput, setPurgeInput] = useState("");
  const [purgeErr, setPurgeErr] = useState("");
  const [purgeLoading, setPurgeLoading] = useState(false);
  const [releaseModal, setReleaseModal] = useState(null);
  const [releaseInput, setReleaseInput] = useState("");
  const [releaseErr, setReleaseErr] = useState("");
  const [releaseLoading, setReleaseLoading] = useState(false);

  async function doAction(shopId, action) {
    if (!window.confirm(`Confermi: ${action}?`)) return;
    setActionLoading(shopId+action);
    try {
      const d = await fetch(`${API}/admin/merchants/${shopId}/${action}`, { method:"POST", headers:{ Authorization:`Bearer ${token}` } }).then(r=>r.json());
      if (action==="reset-api-key" && d.new_api_key) setNewKey({ shopId, key:d.new_api_key });
      delete cache["/admin/merchants"];
      reload();
    } catch {}
    setActionLoading(null);
  }

  function openPurgeModal(m) {
    window.alert(
      "Eliminazione definitiva: verranno rimossi tutti i dati dello shop dal database CartHub (carrelli, AI, impostazioni). Questa azione non è annullabile. Nella finestra successiva dovrai digitare DELETE per confermare."
    );
    setPurgeModal({ id: m.id, name: m.name || "", domain: m.domain || "" });
    setPurgeInput("");
    setPurgeErr("");
  }

  async function confirmPurge() {
    if (!purgeModal) return;
    if (purgeInput !== "DELETE") {
      setPurgeErr("Digita esattamente DELETE (tutto maiuscolo).");
      return;
    }
    setPurgeLoading(true);
    setPurgeErr("");
    try {
      const r = await fetch(`${API}/admin/merchants/${purgeModal.id}/delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ confirmation: "DELETE" }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) {
        setPurgeErr(d.error || `Errore ${r.status}`);
        setPurgeLoading(false);
        return;
      }
      setPurgeModal(null);
      setPurgeInput("");
      delete cache["/admin/merchants"];
      reload();
    } catch {
      setPurgeErr("Richiesta fallita.");
    }
    setPurgeLoading(false);
  }

  function openReleaseModal(m) {
    window.alert(
      "Rilascio dominio e email: il vecchio dominio e la mail diventano liberi per una nuova registrazione. Lo shop mantiene lo stesso ID interno: carrelli, decisioni AI e altro storico restano nel database (nessun buco referenziale). Il negozio viene disattivato e l’API key sostituita. Nella finestra successiva digita RELEASE per confermare."
    );
    setReleaseModal({ id: m.id, name: m.name || "", domain: m.domain || "" });
    setReleaseInput("");
    setReleaseErr("");
  }

  async function confirmRelease() {
    if (!releaseModal) return;
    if (releaseInput !== "RELEASE") {
      setReleaseErr("Digita esattamente RELEASE (tutto maiuscolo).");
      return;
    }
    setReleaseLoading(true);
    setReleaseErr("");
    try {
      const r = await fetch(`${API}/admin/merchants/${releaseModal.id}/release-identity`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ confirmation: "RELEASE" }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) {
        setReleaseErr(d.error || `Errore ${r.status}`);
        setReleaseLoading(false);
        return;
      }
      setReleaseModal(null);
      setReleaseInput("");
      delete cache["/admin/merchants"];
      reload();
    } catch {
      setReleaseErr("Richiesta fallita.");
    }
    setReleaseLoading(false);
  }

  if (loading) return <Loader />;
  if (error || !data) return <ErrMsg />;

  const allMerchants = data.merchants || [];
  const filtered = allMerchants.filter(m => !search || m.name?.toLowerCase().includes(search.toLowerCase()) || m.domain?.toLowerCase().includes(search.toLowerCase()));

  // Raggruppa per agenzia
  const groups = [];
  const agencyMap = {};
  filtered.forEach(m => {
    const key = m.agency_id || '__direct__';
    if (!agencyMap[key]) {
      agencyMap[key] = { agency_id: m.agency_id, agency_name: m.agency_name, merchants: [] };
      groups.push(agencyMap[key]);
    }
    agencyMap[key].merchants.push(m);
  });
  // Ordina: agenzie prima, diretti in fondo
  groups.sort((a, b) => {
    if (a.agency_id && !b.agency_id) return -1;
    if (!a.agency_id && b.agency_id) return 1;
    return (a.agency_name||'').localeCompare(b.agency_name||'');
  });

  const MerchantRow = ({ m }) => {
    const inSilent = m.silent_until && new Date(m.silent_until) > new Date();
    const released = !!m.identity_released_at;
    return (
    <tr key={m.id} style={{ opacity:m.active?1:0.5 }}>
      <td>
        <div style={{ fontWeight:600 }}>{m.name}</div>
        <div className="td-sm">{m.domain}</div>
        {released ? (
          <div style={{ marginTop:6, display:"flex", flexDirection:"column", alignItems:"flex-start", gap:4 }}>
            <Badge status="warning" text="identità rilasciata" />
            <Badge status="inactive" text="disattivo" />
          </div>
        ) : !m.active ? (
          <div style={{ marginTop:6 }}><Badge status="inactive" text="disattivo" /></div>
        ) : null}
      </td>
      <td><Badge status={m.email_tier} text={m.email_tier} />{m.pro_domain&&<div className="td-sm">{m.pro_domain}</div>}</td>
      <td><Badge status={m.deliverability_status} text={m.deliverability_status} /><div className="td-sm">{m.bounce_rate_30d||0}% bounce</div></td>
      <td style={{ maxWidth:200 }}>
        {m.shadow_mode ? <Badge status="warning" text="shadow test" /> : <span className="ch-status success" style={{ fontSize:12 }}><span className="status-dot" />produzione</span>}
        {inSilent && <div style={{ marginTop:4 }}><span className="ch-status warning" style={{ fontSize:11 }}><span className="status-dot" />silent</span></div>}
        {m.email_paused && <div style={{ marginTop:4 }}><span className="ch-status error" style={{ fontSize:11 }}><span className="status-dot" />email in pausa</span></div>}
        <div className="td-muted" style={{ fontSize:11, marginTop:6 }}>Ping: {m.last_seen_at ? fmtDateTime(m.last_seen_at) : "—"}</div>
      </td>
      <td>{fmtNum(m.total_carts)}</td>
      <td><span style={{ fontWeight:600, color:"var(--green)" }}>{m.recovery_rate||0}%</span><div className="td-sm">{fmtNum(m.recovered_carts)} recuperati</div></td>
      <td><span style={{ fontWeight:600 }}>{fmtUSD(m.ai_cost_usd)}</span><div className="td-sm">{fmtNum(m.ai_tokens)} token</div></td>
      <td className="td-muted">{fmtDate(m.created_at)}</td>
      <td>
        <div style={{ display:"flex", flexWrap:"wrap", gap:6, maxWidth:360 }}>
          {!released && (m.active
            ? <button type="button" className="ch-btn danger"  disabled={actionLoading===m.id+"deactivate"}  onClick={()=>doAction(m.id,"deactivate")}>{actionLoading===m.id+"deactivate" ?"...":"Disattiva"}</button>
            : <button type="button" className="ch-btn success" disabled={actionLoading===m.id+"activate"}    onClick={()=>doAction(m.id,"activate")}  >{actionLoading===m.id+"activate"   ?"...":"Attiva"}</button>
          )}
          {!released && <button type="button" className="ch-btn blue" disabled={actionLoading===m.id+"reset-api-key"} onClick={()=>doAction(m.id,"reset-api-key")}>{actionLoading===m.id+"reset-api-key"?"...":"Reset Key"}</button>}
          {!released && (
            <button type="button" className="ch-btn" disabled={releaseLoading && releaseModal?.id===m.id} style={{ borderColor:"#f59e0b", color:"#b45309" }} onClick={()=>openReleaseModal(m)}>Rilascia dominio/email</button>
          )}
          <button type="button" className="ch-btn danger" disabled={purgeLoading && purgeModal?.id===m.id} style={{ borderStyle:"dashed" }} onClick={()=>openPurgeModal(m)}>Elimina tutto</button>
        </div>
      </td>
    </tr>
    );
  };

  return (
    <div>
      <SectionHead title="Merchant" sub={`${allMerchants.length} shop registrati · carrelli/email/AI 30d = produzione + AI live`} onReload={reload} />
      {newKey && (
        <div className="ch-success">
          <span>Nuova API Key: <span className="copy-value">{newKey.key}</span></span>
          <button type="button" onClick={()=>setNewKey(null)} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--green)", display:"flex", padding:4 }} title="Chiudi">{Ic.xSm}</button>
        </div>
      )}
      <input className="ch-search" placeholder="Cerca per nome o dominio..." value={search} onChange={e=>setSearch(e.target.value)} />

      {groups.map(g => (
        <div key={g.agency_id||'__direct__'} style={{ marginBottom:24 }}>
          {/* Header gruppo */}
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8, paddingLeft:2 }}>
            {g.agency_id
              ? <><span style={{ display:"inline-flex", alignItems:"center", gap:6, fontSize:13, fontWeight:700, color:"var(--accent)", textTransform:"uppercase", letterSpacing:".05em" }}>{Ic.agencies}Agenzia</span><span style={{ fontSize:15, fontWeight:700, color:"#1a1a1a" }}>{g.agency_name}</span><span style={{ fontSize:12, color:"#9ca3af" }}>({g.merchants.length} shop)</span></>
              : <><span style={{ display:"inline-flex", alignItems:"center", gap:6, fontSize:13, fontWeight:700, color:"#6b7280", textTransform:"uppercase", letterSpacing:".05em" }}>{Ic.users}Merchant diretti</span><span style={{ fontSize:12, color:"#9ca3af" }}>({g.merchants.length} shop)</span></>
            }
          </div>
          <div className="ch-card" style={{ padding:0 }}>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Shop</th><th>Email Tier</th><th>Deliverability</th><th>Plugin</th><th>Carrelli</th><th>Recovery</th><th>Costo AI</th><th>Creato</th><th>Azioni</th></tr></thead>
                <tbody>
                  {g.merchants.map(m => <MerchantRow key={m.id} m={m} />)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
      {filtered.length===0&&<div className="empty"><div className="empty-svg" style={{ color:"var(--text3)" }}>{Ic.merchants}</div>Nessun merchant trovato</div>}

      {releaseModal && (
        <div
          style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.55)", zIndex:9998, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="release-dialog-title"
          onKeyDown={(e) => { if (e.key === "Escape" && !releaseLoading) { setReleaseModal(null); setReleaseInput(""); setReleaseErr(""); } }}
        >
          <div
            className="ch-card"
            style={{ maxWidth:440, width:"100%", padding:24, border:"1px solid #fcd34d", boxShadow:"0 25px 50px rgba(0,0,0,0.2)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display:"flex", gap:12, alignItems:"center", marginBottom:14, color:"#b45309" }}>
              <span style={{ display:"flex", flexShrink:0 }}>{Ic.alertLg}</span>
              <h2 id="release-dialog-title" style={{ margin:0, fontSize:17, fontWeight:700, color:"#1a1a1a" }}>Rilascio dominio e email</h2>
            </div>
            <p style={{ margin:"0 0 10px", fontSize:14, lineHeight:1.55, color:"#374151" }}>
              Confermi il rilascio per <strong>{releaseModal.domain}</strong>
              {releaseModal.name ? <> ({releaseModal.name})</> : null}? I dati storici restano collegati allo stesso ID shop; dominio e email attuali diventano disponibili per una nuova iscrizione.
            </p>
            <p style={{ margin:"0 0 14px", fontSize:13, color:"#b45309" }}>
              Digita <strong style={{ fontFamily:"ui-monospace, monospace" }}>RELEASE</strong> (maiuscolo).
            </p>
            <input
              className="login-input"
              style={{ width:"100%", marginBottom:8, fontFamily:"ui-monospace, monospace", boxSizing:"border-box" }}
              autoComplete="off"
              autoFocus
              value={releaseInput}
              onChange={(e) => { setReleaseInput(e.target.value); setReleaseErr(""); }}
              placeholder="RELEASE"
            />
            {releaseErr ? <div style={{ color:"var(--red)", fontSize:13, marginBottom:8 }}>{releaseErr}</div> : null}
            <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:10, flexWrap:"wrap" }}>
              <button type="button" className="ch-btn" disabled={releaseLoading} onClick={() => { setReleaseModal(null); setReleaseInput(""); setReleaseErr(""); }}>Annulla</button>
              <button type="button" className="ch-btn" style={{ borderColor:"#f59e0b", color:"#92400e", fontWeight:600 }} disabled={releaseLoading || releaseInput !== "RELEASE"} onClick={confirmRelease}>{releaseLoading ? "..." : "Rilascia"}</button>
            </div>
          </div>
        </div>
      )}

      {purgeModal && (
        <div
          style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.55)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="purge-dialog-title"
          onKeyDown={(e) => { if (e.key === "Escape" && !purgeLoading) { setPurgeModal(null); setPurgeInput(""); setPurgeErr(""); } }}
        >
          <div
            className="ch-card"
            style={{ maxWidth:440, width:"100%", padding:24, border:"1px solid #fecaca", boxShadow:"0 25px 50px rgba(0,0,0,0.2)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display:"flex", gap:12, alignItems:"center", marginBottom:14, color:"var(--red)" }}>
              <span style={{ display:"flex", flexShrink:0 }}>{Ic.alertLg}</span>
              <h2 id="purge-dialog-title" style={{ margin:0, fontSize:17, fontWeight:700, color:"#1a1a1a" }}>Conferma eliminazione</h2>
            </div>
            <p style={{ margin:"0 0 10px", fontSize:14, lineHeight:1.55, color:"#374151" }}>
              Stai per <strong>cancellare in modo irreversibile</strong> lo shop <strong>{purgeModal.domain}</strong>
              {purgeModal.name ? <> ({purgeModal.name})</> : null} e tutti i dati collegati in CartHub (carrelli, sessioni, decisioni AI, impostazioni, URL warmup per questo dominio). La riga viene registrata in audit log.
            </p>
            <p style={{ margin:"0 0 14px", fontSize:13, color:"#b45309" }}>
              Per procedere digita <strong style={{ fontFamily:"ui-monospace, monospace" }}>DELETE</strong> nel campo (maiuscolo, niente spazi).
            </p>
            <input
              className="login-input"
              style={{ width:"100%", marginBottom:8, fontFamily:"ui-monospace, monospace", boxSizing:"border-box" }}
              autoComplete="off"
              autoFocus
              value={purgeInput}
              onChange={(e) => { setPurgeInput(e.target.value); setPurgeErr(""); }}
              placeholder="DELETE"
            />
            {purgeErr ? <div style={{ color:"var(--red)", fontSize:13, marginBottom:8 }}>{purgeErr}</div> : null}
            <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:10, flexWrap:"wrap" }}>
              <button type="button" className="ch-btn" disabled={purgeLoading} onClick={() => { setPurgeModal(null); setPurgeInput(""); setPurgeErr(""); }}>Annulla</button>
              <button type="button" className="ch-btn danger" disabled={purgeLoading || purgeInput !== "DELETE"} onClick={confirmPurge}>{purgeLoading ? "..." : "Elimina definitivamente"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function AiCosts({ token }) {
  const { data, loading, error, reload } = useAdminData("/admin/ai-costs", token);
  if (loading) return <Loader />;
  if (error || !data) return <ErrMsg />;

  return (
    <div>
      <SectionHead title="Costi AI" sub="Ultimi 30 giorni · solo decisioni live (non shadow) · GPT-4O-Mini" onReload={reload} />
      <div className="stats-grid-3">
        <div className="stat-card"><div className="stat-label">Costo Totale (30d)</div><div className="stat-val accent">{fmtUSD(data.summary?.total_cost_usd)}</div><div className="stat-sub">~$0.00025/email</div></div>
        <div className="stat-card"><div className="stat-label">Token Totali</div><div className="stat-val">{fmtNum(data.summary?.total_tokens)}</div><div className="stat-sub">GPT-4O-Mini</div></div>
        <div className="stat-card"><div className="stat-label">Decisioni AI</div><div className="stat-val">{fmtNum(data.summary?.total_decisions)}</div><div className="stat-sub">analisi carrelli</div></div>
      </div>
      <div className="grid-2">
        <div className="ch-card" style={{ padding:0 }}>
          <div style={{ padding:"14px 20px", borderBottom:"1px solid #e5e5e5", fontWeight:600, fontSize:14 }}>Per Merchant</div>
          <table><thead><tr><th>Shop</th><th>Decisioni</th><th>Costo USD</th><th>Fallback</th></tr></thead>
            <tbody>{(data.by_merchant||[]).map((m,i)=>(
              <tr key={i}><td><div style={{ fontWeight:500 }}>{m.shop_name}</div><div className="td-sm">{m.domain}</div></td><td>{fmtNum(m.decisions)}</td><td style={{ fontWeight:600, color:"var(--accent)" }}>${parseFloat(m.cost_usd||0).toFixed(6)}</td><td>{m.fallbacks>0?<span style={{ color:"var(--yellow)" }}>{m.fallbacks}</span>:<span className="td-muted">0</span>}</td></tr>
            ))}</tbody>
          </table>
        </div>
        <div className="ch-card" style={{ padding:0 }}>
          <div style={{ padding:"14px 20px", borderBottom:"1px solid #e5e5e5", fontWeight:600, fontSize:14 }}>Per Giorno</div>
          <table><thead><tr><th>Giorno</th><th>Decisioni</th><th>Costo USD</th><th>Fallback</th></tr></thead>
            <tbody>{(data.by_day||[]).map((d,i)=>(
              <tr key={i}><td style={{ fontWeight:500 }}>{fmtDate(d.day)}</td><td>{fmtNum(d.decisions)}</td><td style={{ fontWeight:600, color:"var(--accent)" }}>${parseFloat(d.cost_usd||0).toFixed(6)}</td><td>{d.fallbacks>0?<span style={{ color:"var(--yellow)" }}>{d.fallbacks}</span>:<span className="td-muted">—</span>}</td></tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Deliverability({ token }) {
  const { data, loading, error, reload } = useAdminData("/admin/deliverability", token);
  if (loading) return <Loader />;
  if (error || !data) return <ErrMsg />;

  return (
    <div>
      <SectionHead title="Deliverability" sub="Stato email infrastructure per merchant" onReload={reload} />
      <div className="ch-card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Shop</th><th>Status</th><th>Bounce Rate</th><th>Email 30d</th><th>Email Tier</th><th>Pro Domain</th><th>Ultimo check</th></tr></thead>
            <tbody>{(data.shops||[]).map(s=>(
              <tr key={s.id}>
                <td><div style={{ fontWeight:600 }}>{s.name}</div><div className="td-sm">{s.domain}</div></td>
                <td><Badge status={s.deliverability_status} text={s.deliverability_status} /></td>
                <td><span style={{ fontWeight:600, color:s.bounce_rate_30d>10?"var(--red)":s.bounce_rate_30d>3?"var(--yellow)":"var(--green)" }}>{s.bounce_rate_30d||0}%</span><div className="td-sm">{fmtNum(s.bounce_count_30d)} bounce</div></td>
                <td>{fmtNum(s.emails_sent_30d)}</td>
                <td><Badge status={s.email_tier} text={s.email_tier} /></td>
                <td className="td-muted">{s.pro_domain||"—"}{s.pro_tier_verified_at&&<div style={{ fontSize:11, color:"var(--green)", display:"flex", alignItems:"center", gap:4, marginTop:2 }}>{Ic.checkSm}{fmtDate(s.pro_tier_verified_at)}</div>}{s.pro_tier_requested_at&&!s.pro_tier_verified_at&&<div style={{ fontSize:11, color:"var(--yellow)", display:"flex", alignItems:"center", gap:4, marginTop:2 }}>{Ic.clock}in attesa</div>}</td>
                <td className="td-muted" style={{ fontSize:13 }}>{fmtDateTime(s.last_bounce_check)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function FallbackLog({ token }) {
  const { data, loading, error, reload } = useAdminData("/admin/fallback-log", token);
  if (loading) return <Loader />;
  if (error || !data) return <ErrMsg />;

  return (
    <div>
      <SectionHead title="Fallback AI Log" sub="Ultimi 30 giorni · solo decisioni live (non shadow)" onReload={reload} />
      {data.fallbacks?.length===0
        ? <div className="ch-info" style={{ display: "flex", alignItems: "center", gap: 10 }}><span style={{ display: "flex", color: "var(--green)" }}>{Ic.checkSm}</span><span>Nessun fallback negli ultimi 30 giorni — sistema AI stabile</span></div>
        : <div className="ch-card" style={{ padding:0 }}>
            <table>
              <thead><tr><th>Data</th><th>Shop</th><th>Cliente</th><th>Motivo</th><th>Schema</th><th>Contract</th><th>Subject generato</th><th>Recuperato</th></tr></thead>
              <tbody>{(data.fallbacks||[]).map(f=>(
                <tr key={f.id}>
                  <td className="td-muted" style={{ fontSize:13, whiteSpace:"nowrap" }}>{fmtDateTime(f.created_at)}</td>
                  <td><div style={{ fontWeight:500 }}>{f.shop_name}</div><div className="td-sm">{f.domain}</div></td>
                  <td className="td-muted" style={{ fontSize:13 }}>{f.customer_email}</td>
                  <td><span className="ch-status warning">{f.fallback_reason||"GPT timeout/error"}</span></td>
                  <td className="td-muted" style={{ fontSize:12 }}>{f.analysis_schema_version || "—"}</td>
                  <td className="td-muted" style={{ fontSize:11, maxWidth:140, overflow:"hidden", textOverflow:"ellipsis" }} title={typeof f.validation_errors === "string" ? f.validation_errors : JSON.stringify(f.validation_errors || [])}>
                    {f.is_valid_analysis === false ? "invalid" : "ok"}
                  </td>
                  <td style={{ fontSize:13, maxWidth:220, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} title={f.subject_generated}>{f.subject_generated||"—"}</td>
                  <td>{f.cart_recovered?<span style={{ color:"var(--green)", display:"inline-flex" }}>{Ic.checkSm}</span>:<span className="td-muted">—</span>}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
      }
    </div>
  );
}

function PluginProductionDistBars({ title, rows }) {
  const list = rows || [];
  const max = Math.max(...list.map((r) => parseInt(r.count || 0, 10)), 1);
  if (!list.length) {
    return (
      <div className="ch-card" style={{ padding: 16 }}>
        <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>{title}</div>
        <div className="td-muted" style={{ fontSize: 13 }}>Nessun dato nel periodo</div>
      </div>
    );
  }
  return (
    <div className="ch-card" style={{ padding: 16 }}>
      <div style={{ fontWeight: 600, marginBottom: 12, fontSize: 14 }}>{title}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {list.map((r, i) => {
          const n = parseInt(r.count || 0, 10);
          const w = max ? Math.round((n / max) * 100) : 0;
          return (
            <div key={i}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 2 }}>
                <span style={{ fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "72%" }} title={r.label}>{r.label || "—"}</span>
                <span className="td-muted">{fmtNum(n)}</span>
              </div>
              <div style={{ height: 6, background: "#f0f0f0", borderRadius: 3, overflow: "hidden" }}>
                <div style={{ width: `${Math.max(w, n ? 4 : 0)}%`, height: "100%", background: "var(--accent)", borderRadius: 3 }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function GlobalLearningPanel({ token }) {
  const summaryEp = "/admin/global-learning/summary";
  const dailyEp = "/admin/global-learning/daily?limit=120";
  const { data: summary, loading: sLoad, error: sErr, reload: sRel } = useAdminData(summaryEp, token);
  const { data: daily, loading: dLoad, error: dErr, reload: dRel } = useAdminData(dailyEp, token);
  const [backfillBusy, setBackfillBusy] = useState(false);
  const [backfillMsg, setBackfillMsg] = useState(null);

  async function runBackfill(replaceAll) {
    const msg = replaceAll
      ? "Eliminare tutti i rollup legacy (schema legacy + fingerprint unknown) e ricalcolare da zero? Può richiedere molti minuti."
      : "Eseguire backfill aggregati storici fino a ieri UTC? Può richiedere diversi minuti.";
    if (!window.confirm(msg)) return;
    setBackfillBusy(true);
    setBackfillMsg(null);
    try {
      const q = replaceAll ? "?replace_all_legacy=true" : "";
      const res = await fetch(`${API}/admin/global-learning/backfill-legacy-aggregates${q}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ replace_all_legacy: replaceAll }),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error || "Errore backfill");
      setBackfillMsg({ ok: true, text: `Completato: ${j.daysProcessed} giorni elaborati.` });
      delete cache[summaryEp];
      delete cache[dailyEp];
      sRel();
      dRel();
    } catch (e) {
      setBackfillMsg({ ok: false, text: e.message });
    } finally {
      setBackfillBusy(false);
    }
  }

  if (sLoad || dLoad) return <Loader />;
  if (sErr || !summary || dErr || !daily) return <ErrMsg />;

  const rows = daily.rows || [];
  const maxBar = Math.max(...rows.map((r) => parseInt(r.emails_sent || 0, 10)), 1);

  return (
    <div>
      <SectionHead
        title="Global Learning (Fase 0)"
        sub="Aggregati cross-tenant senza PII · schema_version=legacy · merchant_policy_fingerprint=unknown (backfill A §8.1). Nessun episodio supervisionato finché non è in whitelist una versione dedicata."
        onReload={() => {
          delete cache[summaryEp];
          delete cache[dailyEp];
          sRel();
          dRel();
        }}
      />
      <div className="ch-info" style={{ marginBottom: 16, fontSize: 13, lineHeight: 1.45 }}>
        Rollup giornaliero per <strong>lingua</strong> (coalesce cart/shop). Solo shop produzione (<code>shadow_mode = false</code>). AI: solo decisioni <code>shadow = false</code>.
        Notte: cron aggiorna <strong>ieri (UTC)</strong>. Date bucket in UTC.
      </div>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Righe rollup</div>
          <div className="stat-val accent">{fmtNum(summary.range?.row_count)}</div>
          <div className="stat-sub">
            {summary.range?.min_day ? new Date(summary.range.min_day).toLocaleDateString("it-IT") : "—"} —{" "}
            {summary.range?.max_day ? new Date(summary.range.max_day).toLocaleDateString("it-IT") : "—"}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Carrelli (totali rollup)</div>
          <div className="stat-val">{fmtNum(summary.totals?.carts_created)}</div>
          <div className="stat-sub">Recuperati: {fmtNum(summary.totals?.carts_recovered)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Email inviate (rollup)</div>
          <div className="stat-val">{fmtNum(summary.totals?.emails_sent)}</div>
          <div className="stat-sub">Decisioni AI live: {fmtNum(summary.totals?.ai_decisions_live)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Costo AI (rollup)</div>
          <div className="stat-val">{fmtUSD(summary.totals?.ai_cost_usd_sum)}</div>
          <div className="stat-sub">Ultimo agg.: {summary.last_updated ? fmtDateTime(summary.last_updated) : "—"}</div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 20 }}>
        <button type="button" className="ch-btn blue" disabled={backfillBusy} onClick={() => runBackfill(false)}>
          {backfillBusy ? "…" : "Backfill storico (upsert)"}
        </button>
        <button type="button" className="ch-btn danger" disabled={backfillBusy} onClick={() => runBackfill(true)}>
          {backfillBusy ? "…" : "Reset + backfill completo"}
        </button>
      </div>
      {backfillMsg && (
        backfillMsg.ok ? (
          <div className="ch-success" style={{ marginBottom: 16 }}>{backfillMsg.text}</div>
        ) : (
          <div className="ch-info" style={{ marginBottom: 16, borderColor: "var(--red-border)", color: "var(--red)" }}>{backfillMsg.text}</div>
        )
      )}
      <div className="ch-card" style={{ padding: 0 }}>
        <div style={{ padding: "14px 20px", borderBottom: "1px solid #e5e5e5", fontWeight: 600, fontSize: 14 }}>Serie giornaliera (max 120 bucket×lingua)</div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Giorno</th>
                <th>Lingua</th>
                <th>Carrelli</th>
                <th>Rec.</th>
                <th>Email</th>
                <th>Open</th>
                <th>Click</th>
                <th>AI</th>
                <th>€ valore</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td className="td-muted" style={{ whiteSpace: "nowrap" }}>
                    {r.bucket_date ? new Date(r.bucket_date).toLocaleDateString("it-IT") : "—"}
                  </td>
                  <td style={{ fontWeight: 600 }}>{r.language_code}</td>
                  <td>{fmtNum(r.carts_created)}</td>
                  <td>{fmtNum(r.carts_recovered)}</td>
                  <td>{fmtNum(r.emails_sent)}</td>
                  <td>{fmtNum(r.emails_opened)}</td>
                  <td>{fmtNum(r.emails_clicked)}</td>
                  <td>{fmtNum(r.ai_decisions_live)}</td>
                  <td>€{parseFloat(r.cart_value_sum || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="ch-card" style={{ marginTop: 16 }}>
        <h2 style={{ fontSize: 14, marginBottom: 12 }}>Email inviate per riga (ultimi bucket in tabella)</h2>
        <div className="trend-chart" style={{ height: 72 }}>
          {rows.slice(0, 28).map((r, i) => {
            const count = parseInt(r.emails_sent || 0, 10);
            const h = count === 0 ? 0 : Math.max((count / maxBar) * 52, 4);
            return (
              <div key={i} className="trend-bar-wrap">
                <div className={`trend-bar${count === 0 ? " empty" : ""}`} style={count > 0 ? { height: h } : {}} title={`${r.language_code} ${r.bucket_date}`} />
              </div>
            );
          })}
        </div>
        <div className="td-muted" style={{ fontSize: 11, marginTop: 8 }}>Barre = prime 28 righe della tabella (ordinamento API: giorno ↓, lingua).</div>
      </div>
    </div>
  );
}

function PluginProduction({ token }) {
  const { data, loading, error, reload } = useAdminData("/admin/plugin-production", token);
  if (loading) return <Loader />;
  if (error || !data) return <ErrMsg />;

  const v = data.vitality || {};
  const op = data.ops || {};
  const fn = data.funnel || {};
  const ai = data.ai || {};
  const dist = data.distributions || {};
  const days = data.window_days || 30;

  const openRate = fn.emails_sent > 0 ? ((fn.emails_opened / fn.emails_sent) * 100).toFixed(1) : "0";
  const clickRate = fn.emails_sent > 0 ? ((fn.emails_clicked / fn.emails_sent) * 100).toFixed(1) : "0";

  return (
    <div>
      <SectionHead
        title="Plugin produzione"
        sub={`Shop non-shadow · AI live (shadow=false) · ultimi ${days} giorni`}
        onReload={reload}
      />
      <div className="ch-info" style={{ marginBottom: 16, fontSize: 13, lineHeight: 1.45 }}>
        Funnel e carrelli: solo shop con <strong>shadow_mode = false</strong>. Costi e distribuzioni AI escludono righe storiche <strong>ai_decisions.shadow = true</strong>.
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Shop produzione (attivi)</div>
          <div className="stat-val">{fmtNum(v.active_production_shops)}</div>
          <div className="stat-sub">su {fmtNum(v.production_shops)} shop non-shadow</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Heartbeat OK (72h)</div>
          <div className="stat-val accent">{fmtNum(v.heartbeat_ok_72h)}</div>
          <div className="stat-sub">{fmtNum(v.heartbeat_stale)} senza ping recente</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Silent / Email pausa</div>
          <div className="stat-val">{fmtNum(op.in_silent_now)}</div>
          <div className="stat-sub">{fmtNum(op.email_paused_shops)} shop con email in pausa</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Intent medio (AI)</div>
          <div className="stat-val">{ai.avg_cart_intent != null ? ai.avg_cart_intent : "—"}</div>
          <div className="stat-sub">cart_intent_score su decisioni live</div>
        </div>
      </div>

      <h2 style={{ fontSize: 15, fontWeight: 600, margin: "24px 0 12px", display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ display: "flex", color: "var(--text2)" }}>{Ic.overview}</span>
        Funnel email & recovery
      </h2>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Carrelli</div>
          <div className="stat-val">{fmtNum(fn.total_carts)}</div>
          <div className="stat-sub">creati nel periodo</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Email inviate</div>
          <div className="stat-val">{fmtNum(fn.emails_sent)}</div>
          <div className="stat-sub">open {openRate}% · click {clickRate}%</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Recuperati</div>
          <div className="stat-val green">{fmtNum(fn.recovered_carts)}</div>
          <div className="stat-sub">{fn.recovery_rate_global || 0}% · €{parseFloat(fn.revenue_recovered || 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Decisioni AI (live)</div>
          <div className="stat-val">{fmtNum(ai.total_decisions)}</div>
          <div className="stat-sub">{fmtUSD(ai.total_cost_usd)} · {ai.fallback_rate || 0}% fallback</div>
        </div>
      </div>

      {(() => {
        const cv = ai.contract_v11 || {};
        const n = cv.rows || 0;
        return (
          <div className="ch-info" style={{ marginTop: 12, fontSize: 13, lineHeight: 1.45 }}>
            <strong>Analysis contract v1.1</strong> (finestra): {fmtNum(n)} righe live con schema 1.1
            {n > 0 ? (
              <>
                {" "}
                · valide <strong>{cv.valid_pct != null ? `${cv.valid_pct}%` : "—"}</strong> ({fmtNum(cv.valid || 0)} ok, {fmtNum(cv.invalid || 0)} con errori)
              </>
            ) : (
              <span className="td-muted"> — nessuna ancora nel periodo (atteso finché non girano nuove analisi post-deploy).</span>
            )}
          </div>
        );
      })()}

      <h2 style={{ fontSize: 15, fontWeight: 600, margin: "24px 0 12px", display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ display: "flex", color: "var(--text2)" }}>{Ic.ai}</span>
        Distribuzioni AI (live)
      </h2>
      <div className="grid-2">
        <PluginProductionDistBars title="Cart personality" rows={dist.by_personality} />
        <PluginProductionDistBars title="Messaging angle (legacy, pre–v1.1)" rows={dist.by_strategy} />
      </div>
      <div style={{ marginTop: 12 }} className="grid-2">
        <PluginProductionDistBars title="Commercial lever (contract v1.1)" rows={dist.by_commercial_lever_v11} />
        <PluginProductionDistBars title="Intent score (fascia)" rows={dist.intent_buckets} />
      </div>
      <div style={{ marginTop: 12 }}>
        <div className="ch-card" style={{ padding: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>Shop senza heartbeat recente</div>
          <div className="td-muted" style={{ fontSize: 12, marginBottom: 10 }}>Attivi, produzione, ultimo ping oltre 72h</div>
          {(data.stale_shops || []).length === 0 ? (
            <div style={{ fontSize: 13, color: "var(--green)", display: "flex", alignItems: "center", gap: 6 }}>
              {Ic.checkSm} Tutti ok
            </div>
          ) : (
            <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, lineHeight: 1.5 }}>
              {data.stale_shops.map((s) => (
                <li key={s.id}>
                  <strong>{s.name}</strong> <span className="td-muted">{s.domain}</span>
                  <div className="td-muted" style={{ fontSize: 11 }}>ultimo ping: {fmtDateTime(s.last_seen_at)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

// ============================================================
// Componente WarmupPanel — invio email bulk per warmup dominio
// ============================================================
function WarmupPanel({ token }) {
  const { data: merchantData } = useAdminData('/admin/merchants', token);
  const [shopDomain, setShopDomain] = useState('');
  const [emailsRaw, setEmailsRaw] = useState('');
  const [delayMs, setDelayMs] = useState(3000);
  const [sending, setSending] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  // URL pool state
  const [urlPool, setUrlPool] = useState([]);
  const [urlInput, setUrlInput] = useState('');
  const [urlLabel, setUrlLabel] = useState('');
  const [urlLoading, setUrlLoading] = useState(false);
  const [urlError, setUrlError] = useState('');

  const shops = merchantData?.merchants || [];

  async function loadUrls(domain) {
    if (!domain) { setUrlPool([]); return; }
    setUrlLoading(true);
    try {
      const res = await fetch(`${API}/admin/warmup-urls?shop_domain=${domain}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const d = await res.json();
      setUrlPool(d.urls || []);
    } catch { setUrlPool([]); }
    finally { setUrlLoading(false); }
  }

  async function addUrl() {
    if (!shopDomain) { setUrlError('Seleziona prima uno shop'); return; }
    const trimmed = urlInput.trim();
    if (!trimmed) { setUrlError('Inserisci un URL'); return; }
    try { new URL(trimmed); } catch { setUrlError('URL non valido (deve iniziare con https://)'); return; }
    setUrlError('');
    try {
      const res = await fetch(`${API}/admin/warmup-urls`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ shop_domain: shopDomain, url: trimmed, label: urlLabel.trim() || null })
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error);
      setUrlPool(prev => [...prev, d.url]);
      setUrlInput(''); setUrlLabel('');
    } catch (e) { setUrlError(e.message); }
  }

  async function deleteUrl(id) {
    try {
      await fetch(`${API}/admin/warmup-urls/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      setUrlPool(prev => prev.filter(u => u.id !== id));
    } catch { /* ignore */ }
  }

  function handleShopChange(domain) {
    setShopDomain(domain);
    setResults(null);
    loadUrls(domain);
  }

  async function handleSend() {
    const emails = emailsRaw.split(/[\n,;]+/).map(e => e.trim()).filter(Boolean);
    if (!shopDomain) { setError('Seleziona uno shop'); return; }
    if (emails.length === 0) { setError('Inserisci almeno un indirizzo email'); return; }
    setError(null);
    setResults(null);
    setSending(true);
    try {
      const res = await fetch(`${API}/admin/warmup-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ to: emails, shop_domain: shopDomain, delay_ms: delayMs })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Errore invio');
      setResults(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  }

  const emailCount = emailsRaw.split(/[\n,;]+/).map(e => e.trim()).filter(Boolean).length;

  return (
    <div>
      <SectionHead title="Warmup Email" sub="Invia email di test per costruire la reputazione del dominio send.carthub.cloud" />

      <div className="ch-card" style={{ maxWidth: 680 }}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#444', marginBottom:6 }}>Shop mittente</label>
          <select
            value={shopDomain}
            onChange={e => handleShopChange(e.target.value)}
            style={{ width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:6, fontSize:14, background:'#fff' }}
          >
            <option value="">— Seleziona shop —</option>
            {shops.map(s => (
              <option key={s.id} value={s.domain}>{s.name} ({s.domain})</option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#444', marginBottom:6 }}>
            Indirizzi email destinatari
            <span style={{ fontWeight:400, color:'#aaa', marginLeft:8 }}>uno per riga, oppure separati da virgola/punto e virgola</span>
          </label>
          <textarea
            value={emailsRaw}
            onChange={e => setEmailsRaw(e.target.value)}
            placeholder={"mario@gmail.com\nluca@yahoo.it\ngiulia@hotmail.com"}
            rows={8}
            style={{ width:'100%', padding:'10px 12px', border:'1px solid #ddd', borderRadius:6, fontSize:13, fontFamily:'monospace', resize:'vertical', boxSizing:'border-box' }}
          />
          {emailCount > 0 && (
            <div style={{ fontSize:12, color:'#888', marginTop:4 }}>{emailCount} indirizzo{emailCount > 1 ? 'i' : 'o'} rilevato{emailCount > 1 ? 'i' : ''}</div>
          )}
        </div>

        <div style={{ marginBottom: 24, display:'flex', alignItems:'center', gap:16 }}>
          <div>
            <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#444', marginBottom:6 }}>
              Pausa tra invii
            </label>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <input
                type="range"
                min={500} max={10000} step={500}
                value={delayMs}
                onChange={e => setDelayMs(parseInt(e.target.value))}
                style={{ width:160 }}
              />
              <span style={{ fontSize:13, color:'#555', minWidth:60 }}>{(delayMs / 1000).toFixed(1)}s</span>
            </div>
            <div style={{ fontSize:11, color:'#aaa', marginTop:2 }}>Tempo di attesa tra un invio e il successivo (anti-spam)</div>
          </div>
        </div>

        {error && (
          <div style={{ display:'flex', alignItems:'center', gap:8, background:'#fff5f5', border:'1px solid #fca5a5', borderRadius:6, padding:'10px 14px', marginBottom:16, fontSize:13, color:'#dc2626' }}>
            <span style={{ display:'flex', flexShrink:0 }}>{Ic.xSm}</span>{error}
          </div>
        )}

        <button
          onClick={handleSend}
          disabled={sending || emailCount === 0 || !shopDomain}
          style={{
            background: sending ? '#9ca3af' : '#0A85CF',
            color:'#fff', border:'none', borderRadius:6,
            padding:'11px 28px', fontSize:15, fontWeight:600, cursor: sending ? 'not-allowed' : 'pointer',
            display:'flex', alignItems:'center', gap:8
          }}
        >
          {sending ? (
            <>
              <span style={{ display:'inline-block', width:14, height:14, border:'2px solid rgba(255,255,255,.4)', borderTopColor:'#fff', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
              Invio in corso…
            </>
          ) : `Invia ${emailCount > 0 ? emailCount : ''} email di warmup`}
        </button>
      </div>

      {results && (
        <div className="ch-card" style={{ maxWidth:680, marginTop:0 }}>
          <div style={{ display:'flex', gap:24, marginBottom:20, paddingBottom:16, borderBottom:'1px solid #f0f0f0' }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:28, fontWeight:700, color:'#16a34a' }}>{results.sent}</div>
              <div style={{ fontSize:12, color:'#888' }}>Inviate</div>
            </div>
            {results.errors > 0 && (
              <div style={{ textAlign:'center' }}>
                <div style={{ fontSize:28, fontWeight:700, color:'#dc2626' }}>{results.errors}</div>
                <div style={{ fontSize:12, color:'#888' }}>Errori</div>
              </div>
            )}
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:13, color:'#555', marginTop:4 }}>{results.sender}</div>
              <div style={{ fontSize:12, color:'#888' }}>Mittente</div>
            </div>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:13, color:'#555', marginTop:4 }}>{results.template}</div>
              <div style={{ fontSize:12, color:'#888' }}>Template</div>
            </div>
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            {results.results.map((r, i) => (
              <div key={i} style={{
                display:'flex', alignItems:'center', gap:10,
                padding:'8px 12px', borderRadius:6,
                background: r.status === 'sent' ? '#f0fdf4' : '#fff5f5',
                border: `1px solid ${r.status === 'sent' ? '#bbf7d0' : '#fca5a5'}`
              }}>
                <span style={{ fontSize:14, display:'flex', color: r.status === 'sent' ? 'var(--green)' : 'var(--red)' }}>{r.status === 'sent' ? Ic.checkSm : Ic.xSm}</span>
                <span style={{ fontSize:13, flex:1, fontFamily:'monospace' }}>{r.email}</span>
                {r.status === 'sent' ? (
                  <span style={{ fontSize:11, color:'#16a34a', maxWidth:220, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={r.landing_url}>
                    → {r.landing_url ? new URL(r.landing_url).pathname || '/' : ''}
                  </span>
                ) : (
                  <span style={{ fontSize:11, color:'#dc2626', maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{r.error}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── Gestione URL pool ── */}
      <div className="ch-card" style={{ maxWidth:680 }}>
        <H2Icon icon={Ic.link}>Pagine di approdo</H2Icon>
        <p style={{ fontSize:13, color:'#6b7280', marginBottom:16 }}>
          {shopDomain
            ? `Ogni email warmup per ${shopDomain} punterà a una di queste pagine, scelta casualmente. Se vuota, usa la homepage dello shop.`
            : 'Seleziona uno shop per gestire le sue pagine di approdo.'}
        </p>

        {shopDomain && (
          <>
            {/* Lista URL esistenti */}
            {urlLoading ? (
              <div style={{ color:'#9ca3af', fontSize:13 }}>Caricamento...</div>
            ) : urlPool.length === 0 ? (
              <div style={{ display:'flex', alignItems:'flex-start', gap:8, background:'#fefce8', border:'1px solid #fde68a', borderRadius:6, padding:'10px 14px', fontSize:13, color:'#92400e', marginBottom:16 }}>
                <span style={{ display:'flex', flexShrink:0, color:'#ca8a04' }}>{Ic.alertLg}</span>
                <span>Nessuna URL configurata — verrà usata la homepage: <code>https://{shopDomain}</code></span>
              </div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:6, marginBottom:16 }}>
                {urlPool.map(u => (
                  <div key={u.id} style={{
                    display:'flex', alignItems:'center', gap:10,
                    padding:'8px 12px', borderRadius:6,
                    background:'#f8fafc', border:'1px solid #e2e8f0'
                  }}>
                    <span style={{ fontSize:13, flex:1 }}>
                      {u.label && <span style={{ fontWeight:600, marginRight:8 }}>{u.label}</span>}
                      <span style={{ fontFamily:'monospace', fontSize:12, color:'#475569' }}>{u.url}</span>
                    </span>
                    <button
                      onClick={() => deleteUrl(u.id)}
                      style={{ background:'none', border:'none', cursor:'pointer', color:'#dc2626', fontSize:16, lineHeight:1, padding:'2px 4px' }}
                      title="Rimuovi"
                    >{Ic.xSm}</button>
                  </div>
                ))}
              </div>
            )}

            {/* Form aggiungi URL */}
            <div style={{ display:'flex', gap:8, alignItems:'flex-end', flexWrap:'wrap' }}>
              <div style={{ flex:2, minWidth:200 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#666', marginBottom:4 }}>URL pagina</label>
                <input
                  type="url"
                  value={urlInput}
                  onChange={e => setUrlInput(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && addUrl()}
                  placeholder="https://negozio.it/categoria/prodotto"
                  style={{ width:'100%', padding:'8px 10px', border:'1px solid #ddd', borderRadius:6, fontSize:13, boxSizing:'border-box' }}
                />
              </div>
              <div style={{ flex:1, minWidth:120 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#666', marginBottom:4 }}>Etichetta (opzionale)</label>
                <input
                  type="text"
                  value={urlLabel}
                  onChange={e => setUrlLabel(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && addUrl()}
                  placeholder="es. Scarpe uomo"
                  style={{ width:'100%', padding:'8px 10px', border:'1px solid #ddd', borderRadius:6, fontSize:13, boxSizing:'border-box' }}
                />
              </div>
              <button
                onClick={addUrl}
                style={{ background:'#0A85CF', color:'#fff', border:'none', borderRadius:6, padding:'8px 18px', fontSize:14, fontWeight:600, cursor:'pointer', flexShrink:0 }}
              >+ Aggiungi</button>
            </div>
            {urlError && <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:12, color:'#dc2626', marginTop:6 }}><span style={{ display:'flex' }}>{Ic.xSm}</span>{urlError}</div>}
          </>
        )}
      </div>
    </div>
  );
}

const TABS = [
  { id: "overview", label: "Overview", icon: Ic.overview },
  { id: "global-learning", label: "Global Learning", icon: Ic.globalLearning },
  { id: "plugin-production", label: "Plugin produzione", icon: Ic.plugin },
  { id: "merchants", label: "Merchant", icon: Ic.merchants },
  { id: "agencies", label: "Agenzie", icon: Ic.agencies },
  { id: "ai-costs", label: "Costi AI", icon: Ic.ai },
  { id: "deliverability", label: "Deliverability", icon: Ic.deliverability },
  { id: "fallback-log", label: "Fallback Log", icon: Ic.fallback },
  { id: "warmup", label: "Warmup Email", icon: Ic.warmup },
];

const TITLES = { "overview":"Overview Globale", "global-learning":"Global Learning", "plugin-production":"Plugin produzione", "merchants":"Merchant", "agencies":"Agenzie", "ai-costs":"Costi AI", "deliverability":"Deliverability", "fallback-log":"Fallback Log", "warmup":"Warmup Email" };


// ============================================================
// Componente AgenciesPanel
// ============================================================
function AgenciesPanel({ token }) {
  const { data, loading, error, reload } = useAdminData('/admin/agencies', token);
  const [acting, setActing] = useState({});
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('pending'); // pending | all

  const act = async (url, agencyId, body = {}) => {
    setActing(a => ({ ...a, [agencyId]: true }));
    try {
      const res = await fetch(`https://app.carthub.cloud/api${url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(body)
      });
      const d = await res.json();
      if (d.success) reload();
      else alert(d.error || 'Errore');
    } catch { alert('Errore di rete'); }
    finally { setActing(a => ({ ...a, [agencyId]: false })); }
  };

  if (loading) return <div style={{padding:32,color:'#6b7280'}}>Caricamento...</div>;
  if (error)   return <div style={{padding:32,color:'#c62828'}}>Errore: {error}</div>;

  const agencies = data?.agencies || [];

  const pending = agencies.filter(a => a.email_verified && !a.active && !a.approved_at && !(a.approved_by||'').startsWith('REJECTED:'));
  const all     = agencies.filter(a => {
    const q = search.toLowerCase();
    return !q || a.name.toLowerCase().includes(q) || a.email.toLowerCase().includes(q);
  });

  const shown = filter === 'pending' ? pending : all;

  const statusBadge = (a) => {
    if ((a.approved_by||'').startsWith('REJECTED:')) return <span style={{background:'#fef2f2',color:'#991b1b',border:'1px solid #fecaca',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>Rifiutata</span>;
    if (!a.email_verified) return <span style={{background:'#fffbeb',color:'#92400e',border:'1px solid #fde68a',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>Email non verificata</span>;
    if (!a.active && !a.approved_at) return <span style={{background:'#eff6ff',color:'#1d4ed8',border:'1px solid #bfdbfe',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>In attesa</span>;
    if (!a.active) return <span style={{background:'#f3f4f6',color:'#374151',border:'1px solid #e5e7eb',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>Disattivata</span>;
    if (a.plan === 'trial') {
      const expired = a.trial_ends_at && new Date(a.trial_ends_at) < new Date();
      return expired
        ? <span style={{background:'#fef2f2',color:'#991b1b',border:'1px solid #fecaca',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>Trial scaduto</span>
        : <span style={{background:'#f0fdf4',color:'#166534',border:'1px solid #bbf7d0',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>Trial attivo</span>;
    }
    return <span style={{background:'#f0fdf4',color:'#166534',border:'1px solid #bbf7d0',borderRadius:4,padding:'2px 8px',fontSize:12,fontWeight:600}}>{a.plan || 'Attiva'}</span>;
  };

  return (
    <div>
      {/* Header + filtri */}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:20,flexWrap:'wrap'}}>
        <div style={{display:'flex',gap:4}}>
          <button onClick={()=>setFilter('pending')}
            style={{padding:'6px 14px',borderRadius:6,border:'1px solid',fontSize:13,fontWeight:500,cursor:'pointer',
              background:filter==='pending'?'#0A85CF':'#fff',
              color:filter==='pending'?'#fff':'#6b7280',
              borderColor:filter==='pending'?'#0A85CF':'#e5e5e5'}}>
            In attesa {pending.length > 0 && <span style={{background:filter==='pending'?'rgba(255,255,255,.3)':'#0A85CF',color:'#fff',borderRadius:20,padding:'0 6px',marginLeft:4,fontSize:12}}>{pending.length}</span>}
          </button>
          <button onClick={()=>setFilter('all')}
            style={{padding:'6px 14px',borderRadius:6,border:'1px solid',fontSize:13,fontWeight:500,cursor:'pointer',
              background:filter==='all'?'#0A85CF':'#fff',
              color:filter==='all'?'#fff':'#6b7280',
              borderColor:filter==='all'?'#0A85CF':'#e5e5e5'}}>
            Tutte ({agencies.length})
          </button>
        </div>
        {filter === 'all' && (
          <input
            value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Cerca per nome o email..."
            style={{padding:'6px 12px',border:'1px solid #e5e5e5',borderRadius:6,fontSize:13,outline:'none',width:240}} />
        )}
        <button type="button" onClick={reload} className="ch-btn" style={{ marginLeft: "auto" }}><span style={{ display: "flex", color: "var(--text2)" }}>{Ic.refresh}</span>Aggiorna</button>
      </div>

      {/* Lista agenzie in attesa: card compatte */}
      {filter === 'pending' && pending.length === 0 && (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:10, padding:40, textAlign:'center', color:'#6b7280', background:'var(--surface-panel)', borderRadius:12, border:'1px solid var(--border)', boxShadow:'var(--shadow-module)' }}>
          <span style={{ display:'flex', color:'var(--green)' }}>{Ic.checkSm}</span>
          <span>Nessuna agenzia in attesa di approvazione</span>
        </div>
      )}

      {filter === 'pending' && pending.map(a => (
        <div key={a.id} style={{background:'#fff',border:'1px solid #e5e5e5',borderRadius:8,padding:'16px 20px',marginBottom:12,display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
          <div style={{flex:1,minWidth:200}}>
            <div style={{fontWeight:600,color:'#1a1a1a',fontSize:15}}>{a.name}</div>
            <div style={{color:'#6b7280',fontSize:13,marginTop:2}}>{a.email}</div>
            {a.website && (
              <a href={a.website} target="_blank" rel="noreferrer" style={{color:'#0A85CF',fontSize:12,textDecoration:'none',marginTop:2,display:'block'}}>
                {a.website.replace(/^https?:\/\//,'')}
              </a>
            )}
            <div style={{color:'#9ca3af',fontSize:12,marginTop:4}}>Registrata: {new Date(a.created_at).toLocaleDateString('it-IT')}</div>
          </div>
          <div style={{display:'flex',gap:8}}>
            <button
              disabled={acting[a.id]}
              onClick={() => act(`/admin/agencies/${a.id}/approve`, a.id)}
              style={{padding:'7px 16px',background:'#0A85CF',color:'#fff',border:'none',borderRadius:6,fontSize:13,fontWeight:600,cursor:'pointer',opacity:acting[a.id]?0.5:1}}>
              {acting[a.id] ? '...' : (<><span style={{ display:'inline-flex', marginRight:6, verticalAlign:'middle' }}>{Ic.checkSm}</span>Approva</>)}
            </button>
            <button
              disabled={acting[a.id]}
              onClick={() => { const r = prompt('Motivo rifiuto (opzionale):'); act(`/admin/agencies/${a.id}/reject`, a.id, { reason: r }); }}
              style={{padding:'7px 16px',background:'#fff',color:'#c62828',border:'1px solid #fecaca',borderRadius:6,fontSize:13,fontWeight:500,cursor:'pointer',opacity:acting[a.id]?0.5:1}}>
              <span style={{ display:'inline-flex', marginRight:6 }}>{Ic.xSm}</span>Rifiuta
            </button>
          </div>
        </div>
      ))}

      {/* Tabella tutte le agenzie */}
      {filter === 'all' && (
        <div style={{background:'#fff',border:'1px solid #e5e5e5',borderRadius:8,overflow:'hidden'}}>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead>
              <tr style={{background:'#f9fafb'}}>
                {['Agenzia','Sito','Stato','Piano','Shop','AI cost 30d','Registrata','Azioni'].map(h => (
                  <th key={h} style={{padding:'10px 14px',textAlign:'left',fontWeight:600,color:'#6b7280',borderBottom:'1px solid #e5e5e5',whiteSpace:'nowrap'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {shown.map((a,i) => (
                <tr key={a.id} style={{borderBottom: i<shown.length-1?'1px solid #f3f4f6':'none'}}>
                  <td style={{padding:'10px 14px'}}>
                    <div style={{fontWeight:600,color:'#1a1a1a'}}>{a.name}</div>
                    <div style={{color:'#9ca3af',fontSize:12}}>{a.email}</div>
                  </td>
                  <td style={{padding:'10px 14px'}}>
                    {a.website
                      ? <a href={a.website} target="_blank" rel="noreferrer" style={{color:'#0A85CF',fontSize:12,textDecoration:'none'}}>{a.website.replace(/^https?:\/\//,'')}</a>
                      : <span style={{color:'#d1d5db',fontSize:12}}>—</span>
                    }
                  </td>
                  <td style={{padding:'10px 14px'}}>{statusBadge(a)}</td>
                  <td style={{padding:'10px 14px',color:'#6b7280'}}>{a.plan || '—'}</td>
                  <td style={{padding:'10px 14px'}}>
                    <span style={{fontWeight:600}}>{a.shop_count || 0}</span>
                    <span style={{color:'#9ca3af',fontSize:12}}> ({a.active_shop_count || 0} attivi)</span>
                  </td>
                  <td style={{padding:'10px 14px',color:'#6b7280'}}>{a.ai_cost_total ? `$${parseFloat(a.ai_cost_total).toFixed(4)}` : '—'}</td>
                  <td style={{padding:'10px 14px',color:'#9ca3af'}}>{new Date(a.created_at).toLocaleDateString('it-IT')}</td>
                  <td style={{padding:'10px 14px'}}>
                    <div style={{display:'flex',gap:6}}>
                      {a.active ? (
                        <button onClick={() => act(`/admin/agencies/${a.id}/deactivate`, a.id)}
                          disabled={acting[a.id]}
                          style={{padding:'4px 10px',background:'#fff',color:'#c62828',border:'1px solid #fecaca',borderRadius:5,fontSize:12,cursor:'pointer',opacity:acting[a.id]?0.5:1}}>
                          Disattiva
                        </button>
                      ) : (
                        <button onClick={() => act(`/admin/agencies/${a.id}/activate`, a.id)}
                          disabled={acting[a.id]}
                          style={{padding:'4px 10px',background:'#fff',color:'#166534',border:'1px solid #bbf7d0',borderRadius:5,fontSize:12,cursor:'pointer',opacity:acting[a.id]?0.5:1}}>
                          Attiva
                        </button>
                      )}
                      {!a.active && !a.approved_at && a.email_verified && !(a.approved_by||'').startsWith('REJECTED:') && (
                        <button onClick={() => act(`/admin/agencies/${a.id}/approve`, a.id)}
                          disabled={acting[a.id]}
                          style={{padding:'4px 10px',background:'#0A85CF',color:'#fff',border:'none',borderRadius:5,fontSize:12,cursor:'pointer',fontWeight:600,opacity:acting[a.id]?0.5:1}}>
                          Approva
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {shown.length === 0 && (
                <tr><td colSpan={7} style={{padding:24,textAlign:'center',color:'#9ca3af'}}>Nessuna agenzia trovata</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { crashed: false }; }
  static getDerivedStateFromError() { return { crashed: true }; }
  render() {
    if (this.state.crashed) return (
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",fontFamily:"system-ui,sans-serif",flexDirection:"column",gap:12,background:"#1b1b1b",color:"#e5e5e5",padding:24}}>
        <div style={{display:"flex",color:"#fbbf24"}}>{Ic.alertLg}</div>
        <div style={{fontSize:16,color:"#d4d4d4",textAlign:"center"}}>Sessione non valida — rieffettuare il login</div>
        <button onClick={()=>{ localStorage.clear(); window.location.reload(); }}
          style={{marginTop:8,padding:"8px 20px",background:"#1a1a2e",color:"#fff",border:"none",borderRadius:6,cursor:"pointer",fontSize:14}}>
          Accedi di nuovo
        </button>
      </div>
    );
    return this.props.children;
  }
}

function avName(n) {
  return (n || "?").split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);
}

export default function App() {
  const [token, setToken] = useState(()=>localStorage.getItem("carthub_admin_token"));
  const [admin, setAdmin] = useState(()=>{ try { return JSON.parse(localStorage.getItem("carthub_admin")); } catch { return null; } });
  const [tab, setTab] = useState("overview");
  const [pendingAgencies, setPendingAgencies] = useState(0);
  const [validating, setValidating] = useState(!!localStorage.getItem("carthub_admin_token"));
  const [navOpen, setNavOpen] = useState(false);

  // Valida il token all'avvio — se scaduto/invalido pulisce localStorage e mostra login
  useEffect(() => {
    if (!token) { setValidating(false); return; }
    fetch(`${API}/admin/overview`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        if (r.status === 401 || r.status === 403) {
          localStorage.removeItem("carthub_admin_token");
          localStorage.removeItem("carthub_admin");
          setToken(null);
          setAdmin(null);
        }
      })
      .catch(() => {})
      .finally(() => setValidating(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/admin/agencies`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => {
        const count = (d.agencies || []).filter(a => a.email_verified && !a.active && !a.approved_at && !(a.approved_by||'').startsWith('REJECTED:')).length;
        setPendingAgencies(count);
      }).catch(() => {});
  }, [token]);

  useEffect(() => {
    if (!navOpen) return;
    const onKey = (e) => { if (e.key === "Escape") setNavOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navOpen]);

  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 900) setNavOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  function handleLogin(t, a) { setToken(t); setAdmin(a); }
  function handleLogout() { localStorage.removeItem("carthub_admin_token"); localStorage.removeItem("carthub_admin"); setToken(null); setAdmin(null); }

  if (validating) {
    return (
      <>
        <style>{styles}</style>
        <div className="app-loading-screen">
          <div className="app-loading-spinner" aria-hidden />
          <div>Verifica sessione…</div>
        </div>
      </>
    );
  }

  return (
    <ErrorBoundary>
      <style>{styles}</style>
      {!token ? <Login onLogin={handleLogin} /> : (
        <div className="app">
          <div
            className={`sidebar-backdrop${navOpen ? " is-open" : ""}`}
            onClick={() => setNavOpen(false)}
            aria-hidden={!navOpen}
          />
          <aside className={`sidebar${navOpen ? " is-open" : ""}`}>
            <div className="sidebar-head">
              <div className="sidebar-logo" aria-label="CartHub">
                Cart<span>Hub</span>
              </div>
              <div className="sidebar-sub">Superadmin</div>
            </div>
            <nav className="sidebar-nav">
              {TABS.map((t) => (
                <div
                  key={t.id}
                  className={`nav-item${tab === t.id ? " active" : ""}`}
                  onClick={() => { setTab(t.id); setNavOpen(false); }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setTab(t.id); setNavOpen(false); } }}
                >
                  {t.icon}
                  {t.label}
                  {t.id === "agencies" && pendingAgencies > 0 && (
                    <span className="nav-badge">{pendingAgencies}</span>
                  )}
                </div>
              ))}
            </nav>
            <div className="sidebar-foot">
              <div className="admin-row">
                <div className="admin-av">{avName(admin?.name)}</div>
                <div className="admin-email">{admin?.email}</div>
                <button type="button" className="logout-btn" onClick={handleLogout} title="Logout">
                  {Ic.logout}
                </button>
              </div>
            </div>
          </aside>
          <div className="main">
            <div className="topbar">
              <button
                type="button"
                className="mobile-nav-toggle"
                aria-label="Apri menu di navigazione"
                aria-expanded={navOpen}
                onClick={() => setNavOpen((o) => !o)}
              >
                {Ic.menu}
              </button>
              <span className="topbar-title">{TITLES[tab]}</span>
              <span className="pill green"><span className="status-dot" />Sistema operativo</span>
            </div>
            <div className="content">
              {tab==="overview"       && <Overview       token={token} />}
              {tab==="global-learning" && <GlobalLearningPanel token={token} />}
              {tab==="plugin-production" && <PluginProduction token={token} />}
              {tab==="merchants"      && <Merchants      token={token} />}
              {tab==="ai-costs"       && <AiCosts        token={token} />}
              {tab==="deliverability" && <Deliverability token={token} />}
              {tab==="agencies"       && <AgenciesPanel  token={token} />}
              {tab==="fallback-log"   && <FallbackLog    token={token} />}
              {tab==="warmup"         && <WarmupPanel    token={token} />}
            </div>
          </div>
        </div>
      )}
    </ErrorBoundary>
  );
}
